import { Injectable } from '@angular/core';
import { LayerThematicStylesDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { LayerItemV2 } from '@common-modules/wlm-map/generic-map/models/layer-item';
import { LayerVisibilityChangeEvent } from '@common-modules/wlm-map/generic-map/models/layer-visibility-change-event';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayerEventsService {
  private _selectedLayerItem$ = new BehaviorSubject<LayerItemV2 | null>(null);
  selectedLayerItem$ = this._selectedLayerItem$.asObservable();

  private _layerVisibility$ = new BehaviorSubject<LayerVisibilityChangeEvent | null>(null);
  layerVisibility$ = this._layerVisibility$.asObservable();

  private _newThematic$ = new BehaviorSubject<LayerThematicStylesDto>(null);
  newThematic$ = this._newThematic$.asObservable();

  private _editThematic$ = new BehaviorSubject<LayerThematicStylesDto>(null);
  editThematic$ = this._editThematic$.asObservable();

  private _allLayersVisibles$ = new BehaviorSubject<LayerItemV2[]>(null);
  allLayersVisibles$ = this._allLayersVisibles$.asObservable();

  private _thematicToDelete$ = new BehaviorSubject<LayerItemV2>(null);
  thematicToDelete$ = this._thematicToDelete$.asObservable();

  setSelectedLayerItem(item: LayerItemV2): void {
    this._selectedLayerItem$.next(item);
  }

  setLayerVisibility(layer: LayerItemV2, visible: boolean): void {
    this._layerVisibility$.next({ layerItem: layer, visible });
  }

  setNewThematic(thematic: LayerThematicStylesDto): void {
    this._newThematic$.next(thematic);
  }

  setEditThematic(thematic: LayerThematicStylesDto): void {
    this._editThematic$.next(thematic);
  }

  deleteNewThematic(thematic: LayerItemV2): void {
    this._thematicToDelete$.next(thematic);
  }

  setAllLayersVisibles(layers: LayerItemV2[]): void {
    this._allLayersVisibles$.next(layers);
  }
}
